import { OrderDocumentResponse, OrderLineDocumentResponse, Status } from '@ravago/shared/page-data/models/elements';

export const hasOrderDocuments = (documents: OrderDocumentResponse | OrderLineDocumentResponse) => {
   const { deliveryNotes, billsOfLading, invoices, coa } = documents;
   return (
      (invoices && invoices.length > 0) ||
      (coa && coa.length > 0) ||
      (deliveryNotes && deliveryNotes.length > 0) ||
      (billsOfLading && billsOfLading.length > 0)
   );
};

export const getStatusTranslation = (status: Status): string => {
   const mapToTranslation: { [key in Status]: string } = {
      'Order Received': 'order.status.order-received',
      Planned: 'order.status.processing',
      Processing: 'order.status.processing',
      'Order Confirmed': 'shipment.status.order-confirmed',
      'Transport Arranged': 'order.status.transport-arranged',
      'In Transit': 'order.status.in-transit',
      Closed: 'order.status.closed',
      Invoiced: 'order.status.invoiced',
      Credited: 'order.status.credited',
      'Awaiting Call Off': 'order.status.awaiting-call-off',
      'Call Off Overdue': 'order.status.call-off-overdue'
   };
   return mapToTranslation[status];
};
